import { tableViewNames } from '../../../../agent-production/constants/agentProductionConstants';
import { modules } from '../../../../constants';

export const CROSS_SORT_MODULES = [
    modules.proficiencyMetrics.agents,
    modules.proficiencyMetrics.offices,
    modules.proficiencyMetrics.savedAgents,
    modules.proficiencyMetrics.transactions,
];

export const CROSS_SORT_TABLES = [
    tableViewNames.overview,
    tableViewNames.contactInformation,
    tableViewNames.growthAnalysisLtm,
    tableViewNames.growthAnalysisYtd,
    tableViewNames.listingProficiency,
]

export const getIsCrossSortEnabled = (module, tableViewName) => {
    return CROSS_SORT_MODULES.includes(module) && CROSS_SORT_TABLES.includes(tableViewName);
};
